import React from 'react'
import * as R from 'ramda'

import {List, ListItem} from 'material-ui/List'
import { sortProjects } from 'utils/stuff'
import TextField from 'material-ui/TextField'

import ResultCard from './ResultCard'

export default (o) => (
	<div id="main-content"
		style={{
			marginLeft: (o.navPanelIsOpened)?"230px" : '0'
		  , marginRight: (o.rightStackOpened)? '600px':(o.filtersIsOpened)?"230px": "0"
		  , marginTop: "50px"
		  , overflow: 'scroll'
		  , height: 'calc(100vh - 45px)'
		  , ...o.style
		}}
	>
		<TextField
			style={{
				marginTop: '64px'
			}}
			onChange={o.onSearchChange}
		/>
		<List>
			{
				(R.keys(o.results).length)?
					R.map((result) => (
						(result)?
							<ResultCard
								key={`project-${result.docID}-${result.date}`}
								props={result}
								data={o.data}
							/>
						: <div key={`project-${Math.random(1)}`}></div>
				), o.results)
					: (o.searchStr.length)?
						<p style={{margin: "20px", color: "#A0A0A0"}}>No results</p>
						: <p style={{margin: "20px", color: "#A0A0A0"}}>Please enter name property/manager/tenant/repairman</p>
			}
		</List>
	</div>
)



// WEBPACK FOOTER //
// ./src/routes/manager/search/ResultsList.js